import React, { useState } from "react";

const Header = ({ person }) => {
  const [buttons, setButtons] = useState({ membership: false, reservations: false, mobile: false });
  return (
    <div className="header" style={{ top: 0 }} title="header" role="navigation">
      <div>
        <div className="mobile-navigation show-mobile">
          <div className="mobile-navigation-logo-container">
            <svg width="40" height="40" viewBox="0 0 43 40">
              <g fill="currentColor">
                <path d="M18.1,0v36H0c2.5,0,4.6-2.1,4.6-4.5v-27C4.6,2.1,2.7,0,0.3,0H18.1z M28.6,8.5c0-6.2-1.4-8.5-6.7-8.5c13.7,0.2,19.6,2.1,19.6,8.5c0,6.4-5.4,9.1-19.6,9.1C27.3,17.6,28.6,14.9,28.6,8.5z M43,26.6c0,6.7-6.2,9.4-21.1,9.4c5.6,0,7.1-3.1,7.1-9.4c0-6.4-1.9-9-7.1-9C36.3,17.6,43,19.7,43,26.6z" />
              </g>
            </svg>
          </div>
          <div className="hamburger-menu" onClick={() => setButtons({ ...buttons, mobile: true })}>
            <svg x="0px" y="0px" height="20px" width="20px">
              <g>
                <g>
                  <rect x="0" y="0" fill="#FFFFFF" width="20" height="2" />
                </g>
                <g>
                  <rect x="0" y="5" fill="#FFFFFF" width="20" height="2" />
                </g>
                <g>
                  <rect x="0" y="10" fill="#FFFFFF" width="20" height="2" />
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div className="expanded-nav show-mobile">
          <div
            className="nav-menu"
            style={{ transform: `translateX(${buttons.mobile ? "0%" : "-100%"})` }}
          >
            <div
              className="absolute-x"
              style={{ cursor: "pointer" }}
              onClick={() => setButtons({ ...buttons, mobile: false })}
            >
              <div className="off-screen-content">Close Menu</div>
              <svg width="30px" height="30px" preserveAspectRatio="none" aria-hidden="true">
                <g strokeWidth="1" stroke="#FFFFFF">
                  <line x1="0" y1="15" x2="30" y2="15" transform="rotate(45, 15, 15)" />
                  <line x1="30" y1="15" x2="0" y2="15" transform="rotate(315, 15, 15)" />
                </g>
              </svg>
            </div>
            <div className="mobile-menu-username">{person && person.first_name}</div>
            <div className="mobile-menu-tabs battery-link">
              <a href="/account/">Dashboard</a>
            </div>
            <div className="mobile-menu-tabs battery-link">
              <a href="/">Home</a>
            </div>
            <div className="mobile-menu-tabs batterypowered-link batterypowered-mobile-menu mobile-menu-switch-link">
              <a href="/batterypowered">Battery Powered</a>
            </div>
            <div className="mobile-menu-tabs battery-link">
              <a href="/join">Join</a>
            </div>
            <div className="mobile-menu-tabs battery-link">
              <a href="/alliance">Alliance</a>
            </div>
            <div className="mobile-menu-tabs battery-link">
              <a href="/fringe-benefits/events">Fringe Benefits</a>
            </div>
            <div className="mobile-menu-tabs battery-link">
              <a href="/events">Events</a>
            </div>
            <div className="mobile-menu-tabs battery-link">
              <a href="/societies">Societies</a>
            </div>
            <div className="mobile-menu-tabs battery-link">
              <a href="/dining">Dining</a>
            </div>
            <div className="mobile-menu-tabs battery-link">
              <a href="/art">Art</a>
            </div>
            <div className="mobile-menu-tabs battery-link">
              <a href="/travel">Travel</a>
            </div>
            <div className="mobile-menu-tabs battery-link">
              <a href="/hotel">Hotel</a>
            </div>
            <div className="mobile-menu-tabs battery-link">
              <a href="/private-events">Private Events</a>
            </div>
            <div className="mobile-menu-address battery-link">717 Battery Street</div>
            <div className="mobile-menu-number battery-link">415.230.8000</div>
            <div className="mobile-menu-number battery-link mobile-menu-footer">
              <a href="/about">About</a>
              <a href="/careers">Careers</a>
              <a href="/press">Press</a>
              <a href="/privacy-policy">Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="navigation hide-mobile">
          <div className="flexible section-button nav-link to-batterypowered">
            <a className="" href="/batterypowered">
              <div className="top-nav">Battery Powered</div>
              <p className="top-nav-supporting">Be Generous</p>
            </a>
          </div>
          <div
            className={`flexible section-button nav-dropdown ${
              buttons.membership ? "drop-down-button" : ""
            }`}
            onMouseOver={() => setButtons({ ...buttons, membership: true })}
            onMouseOut={() => setButtons({ ...buttons, membership: false })}
          >
            <div
              id="menuMembershipLabel"
              aria-haspopup="true"
              aria-controls="menuMembershipControl"
              role="button"
              tabIndex="0"
            >
              <div className="top-nav">Membership</div>
              <p className="top-nav-supporting">Join Us</p>
            </div>
            <div
              className={`drop-down-items ${buttons.membership ? "drop-down-items-visible" : ""}`}
              id="menuMembershipControl"
              aria-labelledby="menuMembershipLabel"
              role="menu"
            >
              <div className="flexible section-button nav-link">
                <a href="/join" className="" role="menuitem">
                  <div className="top-nav">Join</div>
                </a>
              </div>
              <div className="flexible section-button nav-link">
                <a href="/alliance" className="" role="menuitem">
                  <div className="top-nav">Alliance</div>
                </a>
              </div>
              <div className="flexible section-button nav-link">
                <a href="/fringe-benefits/events" className="" role="menuitem">
                  <div className="top-nav">Fringe Benefits</div>
                </a>
              </div>
            </div>
          </div>
          <div className="flexible section-button nav-link">
            <a className="" href="/events">
              <div className="top-nav">Events</div>
              <p className="top-nav-supporting">Be Together</p>
            </a>
          </div>
          <div className="flexible section-button nav-link nav-link-logo">
            <a className="" href="/">
              <div className="top-nav">
                <svg width="40" height="40" viewBox="0 0 43 40" aria-label="home">
                  <g fill="currentColor">
                    <path d="M18.1,0v36H0c2.5,0,4.6-2.1,4.6-4.5v-27C4.6,2.1,2.7,0,0.3,0H18.1z M28.6,8.5c0-6.2-1.4-8.5-6.7-8.5c13.7,0.2,19.6,2.1,19.6,8.5c0,6.4-5.4,9.1-19.6,9.1C27.3,17.6,28.6,14.9,28.6,8.5z M43,26.6c0,6.7-6.2,9.4-21.1,9.4c5.6,0,7.1-3.1,7.1-9.4c0-6.4-1.9-9-7.1-9C36.3,17.6,43,19.7,43,26.6z" />
                  </g>
                </svg>
              </div>
            </a>
          </div>
          <div className="flexible section-button nav-link">
            <a className="" href="/societies">
              <div className="top-nav">Societies</div>
              <p className="top-nav-supporting">Connect</p>
            </a>
          </div>
          <div
            className={`flexible section-button nav-dropdown ${
              buttons.reservations ? "drop-down-button" : ""
            }`}
            onMouseOver={() => setButtons({ ...buttons, reservations: true })}
            onMouseOut={() => setButtons({ ...buttons, reservations: false })}
          >
            <div
              id="menuReservationsLabel"
              aria-haspopup="true"
              aria-controls="menuReservationsControl"
              role="button"
              tabIndex="0"
            >
              <div className="top-nav">Reservations</div>
              <p className="top-nav-supporting">Book Now</p>
            </div>
            <div
              className={`drop-down-items ${buttons.reservations ? "drop-down-items-visible" : ""}`}
              id="menuReservationsControl"
              aria-labelledby="menuReservationsLabel"
              role="menu"
            >
              <div className="flexible section-button nav-link">
                <a href="/hotelreservations/" className="" role="menuitem">
                  <div className="top-nav">Hotel</div>
                </a>
              </div>
              <div className="flexible section-button nav-link">
                <a href="/dining/" className="" role="menuitem">
                  <div className="top-nav">Dining</div>
                </a>
              </div>
            </div>
          </div>
          <div className="flexible section-button nav-link">
            <a className=" nav-link-active" aria-current="page" href="/account/">
              <div className="top-nav">Hello {person && person.first_name}</div>
              <p className="top-nav-supporting">Member Dashboard</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
